<fieldset class="no-legend">
	<div class="column-100 checklist">
		<div class="checklist-item" *ngFor="let action of actions" (click)="setSelectedAction(action)">
			<gmt-radio [gmtChecked]="isChecked(action)"></gmt-radio> {{ action.name }}
		</div>
	</div>
</fieldset>